import React, { Fragment, ReactElement } from 'react';
import VgsInputLabel from './VgsInput/VgsInputLabel';
import ErrorMessageField from './VgsInput/ErrorMessage';

export default function BaseInput({
  className = 'w-full',
  labelClassName,
  label,
  required,
  showRequiredAsterisk,
  invalid,
  dirty,
  empty,
  children,
  border,
  backgroundColor,
  name,
  errorMessage,
  scrollY = false,
}: {
  className?: string;
  labelClassName?: string;
  label: string;
  required?: boolean;
  showRequiredAsterisk?: boolean;
  invalid?: boolean;
  dirty?: boolean;
  empty?: boolean;
  children: ReactElement;
  border?: string;
  backgroundColor?: string;
  name?: string;
  errorMessage?: string;
  scrollY?: boolean;
}): React.JSX.Element {
  return (
    <div className={className}>
      <VgsInputLabel
        label={label}
        required={showRequiredAsterisk || false}
        className={labelClassName}
      />
      <div className='md:flex mt-1'>
        <div className='w-full'>
          <div
            className={`relative ${scrollY ? 'overflow-y-scroll' : ''}`}
            style={{
              border,
              borderRadius: '10px',
              height: '2.33rem',
              backgroundColor: backgroundColor,
            }}
          >
            {children}
          </div>
          {name !== undefined && (
            <Fragment>
              {required && dirty && empty && (
                <ErrorMessageField message='Field is required.' />
              )}
              {invalid && dirty && (
                <ErrorMessageField message='Field is invalid.' />
              )}
              {errorMessage && <ErrorMessageField message={errorMessage} />}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
}
